module.exports = __webpack_public_path__ + "img/sliders-04.c79adbd8.jpg";